<template>
  <section class="cont-exito">
    <div class="container">
      <div class="exito-bienvenida"></div>
    </div>
    <v-dialog v-model="loadingRecovery" persistent width="300">
      <v-card color="primary" dark>
        <div class="ma-2">
          <v-card-text>
            <p>{{ this.$i18n.t("contract.guide.desktopGuide.recovery") }}</p>
            <v-progress-linear indeterminate color="white"></v-progress-linear>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
export default {
  name: "Success",
  data() {
    return {
      loadingRecovery: false,
      token: null,
    };
  },
  methods: {},
  beforeMount() {
    this.$router.push("/");
  },
  // async beforeMount() {
  //   this.loadingRecovery = true;
  //   if (this.$route.query.token) {
  //     this.token = this.$route.query.token;
  //     try {
  //       const response = await this.axios.post(
  //         `${process.env.VUE_APP_BACKEND}mobile/verify`,
  //         {
  //           token: this.token,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             "Access-Control-Allow-Origin": "*",
  //           },
  //         },
  //       );
  //       if (response.data.code !== 200) {
  //         this.$router.push("/");
  //       }
  //       // eslint-disable-next-line no-undef
  //       heap.identify(response.data.data.email);
  //       this.$store.commit("updateUserData", response.data.data);
  //       this.$store.commit("updateFormStep", { step: 4 });
  //       this.$router.push("contracts");
  //     } catch {
  //       this.$router.push("/");
  //     }
  //   } else {
  //     this.$router.push("/");
  //   }
  // },
};
</script>

<style scoped>
.succcess-text {
  color: white !important;
}
</style>
